<template>
  <div>
    <Card>
      <template #title>Atividades</template>
      <template #content>
        <DataTable
          class="p-datatable-sm"
          :paginator="true"
          :rows="5"
          stripedRows
          :loading="loading"
          :value="atividades"
          dataKey="id"
          :filters.sync="filtros"
          :globalFilterFields="['nome']"
          filterDisplay="menu"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} atividades"
          responsiveLayout="scroll">
          <template #empty> Nenhuma consignatária encontrada. </template>
          <template #loading> Carregando. Por favor aguarde. </template>
          <template #header>
            <span class="mt-2 mr-2 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filtros['global'].value"
                placeholder="Pesquisar"
                style="width: 100%" />
            </span>
            <Button
              icon="pi pi-filter-slash"
              label="Limpar"
              class="mt-2 mr-2 p-button-outlined"
              @click="limparFiltro" />
            <Button
              label="Novo"
              icon="pi pi-plus"
              class="mt-2 mr-2 p-button-success float-right"
              @click="showFormAtividade()" />
          </template>
          <Column field="id" header="ID"></Column>
          <Column field="nome" header="Nome"></Column>
          <Column field="colunaMargem" header="Coluna Margem"></Column>
          <Column header="Status">
            <template #body="slotProps">
              <Chip
                v-if="slotProps.data.ativo"
                label="ATIVO"
                class="mr-2 mb-2 custom-chip emUso" />
              <Chip
                v-else
                label="INATIVO"
                class="mr-2 mb-2 custom-chip foraUso" />
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                v-tooltip.left="'Editar'"
                icon="pi pi-pencil"
                class="p-button-rounded p-button-warning mr-2"
                @click="showFormAtividade(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
      </template>
      <template #footer> </template>
    </Card>
    <AtividadeForm
      :visible.sync="showAtividadeFormDialog"
      :propsatividade="atividade"
      :update="update"
      @carregarDados="carregarDados"
      @onUpdate="onUpdateAtividade" />
    <Toast />
  </div>
</template>

<script>
import { FilterMatchMode, FilterOperator } from 'primevue/api/'
import AtividadeForm from './AtividadeForm.vue'
import AtividadeService from '@/service/AtividadeService.js'

export default {
  components: {
    AtividadeForm,
  },
  data() {
    return {
      filtros: {},
      atividades: null,
      atividade: {},
      deleteAtividadeDialog: false,
      loading: false,
      totalRecords: 0,
      lazyParams: {},
      showAtividadeFormDialog: false,
      update: false,
    }
  },

  created() {
    this.atividadeService = new AtividadeService(this.$http)
    this.initFiltros()
  },

  mounted() {
    this.carregarDados()
  },

  methods: {
    showFormAtividade(data) {
      if (data) {
        this.atividade = data
        this.update = true
      } else {
        this.atividade = {}
        this.update = false
      }
      this.showAtividadeFormDialog = true
    },
    onUpdateAtividade(event) {
      let index = this.atividades.findIndex((a) => a.id === event.id)
      index != -1
        ? this.$set(this.atividades, index, event)
        : this.atividades.unshift(event)
    },
    carregarDados() {
      this.loading = true
      this.atividadeService.getListaAtividades().then((res) => {
        this.atividades = res
        this.loading = false
      })
    },

    limparFiltro() {
      this.initFiltros()
    },

    initFiltros() {
      this.filtros = {
        global: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.CONTAINS },
            { value: null, matchMode: FilterMatchMode.EQUALS },
          ],
        },
      }
    },

    addAtividade() {
      this.$router.push({ name: 'atividade-nova' })
    },
  },
}
</script>
<style scoped>
.foraUso {
  color: #fff;
  background-color: #dc3545;
  font-weight: bold;
  text-align: center;
}
.emUso {
  color: #fff;
  background-color: #28a745;
  font-weight: bold;
  text-align: center;
}
</style>
